// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:38
import { SagaObject } from '../../SagaBase/SagaObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class Intruder_abstract extends SagaObject {
  static $t: string = 'SagaSchema.Intruder';
  $t: string = 'SagaSchema.Intruder';

  public static GetMembers(): string[] {
    return ['MapX', 'MapY', 'ResourceUid', 'ResourceName', 'Description', 'IntruderType'].concat(SagaObject.GetMembers());
  }

  public GetMembers(): string[] {
    return Intruder_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public MapX: number = -1.79769313486232e308;
  public MapY: number = -1.79769313486232e308;
  public ResourceUid: Guid = GuidTools.Empty;
  public ResourceName: string;
  public Description: string;
  public IntruderType: number = 0;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
